import { useEffect, useState } from "react";
import { Box, HStack, Stack, Text } from "@chakra-ui/react";
import Tooltip from "../../theme/Tooltip";

export default function SizeSelect(props) {
  const { onChange, selectedValue, sizeItems } = props;
  const sizes = Object.keys(sizeItems || {}); 
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setSelected(selectedValue);
  }, [selectedValue]);

    const colors = {
        "size.bg": "gray.50",
        "size.bg.hover": "gray.100",
        "size.bg.selected": "red.500",
        "size.fg": "gray.800",
        "size.fg.selected": "white",
        "size.border": "gray.300",
        "size.border.hover": "gray.400",
        "size.border.selected": "red.500",
        "size.outline": "red.500",
    }

  return (
    <Stack gap="4">
      <HStack wrap="wrap">
        {sizes.map((size) => {
            const isActive = selected === size;
            // Get the count for the size
            const count = sizeItems[size] || 0; 
            return (
            <Tooltip 
                content={`${size} (${count})`} 
                positioning={{ placement: "top" }}
                key={size}
            >
                <Box
                    as="button"
                    onClick={() => {setSelected(size);onChange(size)}}
                    h="28px"
                    minW="38px"
                    px="1"
                    rounded="sm"
                    fontSize="12px"
                    fontWeight="semibold"
                    letterSpacing="wide"
                    borderWidth="1px"
                    transition="all 0.15s ease"
                    bg={isActive ? colors["size.bg.selected"] : colors["size.bg"]}
                    color={isActive ? colors["size.fg.selected"] : colors["size.fg"]}
                    borderColor={isActive ? colors["size.border.selected"] : colors["size.border"]}
                    _hover={{
                    bg: isActive ? colors["size.bg.selected"] : colors["size.bg.hover"],
                    borderColor: isActive
                        ? colors["size.border.selected"]
                        : colors["size.border.hover"],
                    }}
                    _focusVisible={{
                    outline: "2px solid",
                    outlineColor: colors["size.outline"],
                    }}
                >
                    {size}
                </Box>
            </Tooltip>
            );
        })}
        {sizes.length === 0 && <Text fontSize="xs" color="gray.500">No sizes available</Text>}
      </HStack>
    </Stack>
  );
}